import { render, staticRenderFns } from "./BatchSendToBoss.vue?vue&type=template&id=657f300a&scoped=true"
import script from "./BatchSendToBoss.vue?vue&type=script&lang=js"
export * from "./BatchSendToBoss.vue?vue&type=script&lang=js"
import style0 from "./BatchSendToBoss.vue?vue&type=style&index=0&id=657f300a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657f300a",
  null
  
)

export default component.exports